module.exports = __webpack_public_path__ + "img/图层44拷贝.6dc175da.png";